import {Context} from '@/project'
import {Transformer} from '@/lib/axiosAddTransforms'

const ACCESS_TOKEN_NAME = 'Authorization'
const JWT_HEADER = 'JWT'

/**
 * Add accessToken in headers
 * @param payload
 * @param context
 */
const accessToken: Transformer<Context> = (payload, context) => {
  const {accessToken: storeAccessToken} = context && context.store.state.auth
  const {accessToken: headerAccessToken} = payload.headers
  delete payload.headers.accessToken
  const accessToken = headerAccessToken || storeAccessToken || ''
  payload.headers[ACCESS_TOKEN_NAME] = `${JWT_HEADER} ${accessToken}`
  return payload
}

export default accessToken
